import styles from './DocumentListHeader.module.css'
import { Icon } from '@/components/Icon'
import { SearchField } from '@/components/SearchField'
import { Tooltip } from '@/components/Tooltip'
import { FileButton } from '@/components/FileButton'

export interface DocumentListHeaderProps {
  searchText: string
  onSearchTextChange: (text: string) => unknown
  onQueueFilesUpload: (files: FileList) => void
  showUploadAction: boolean
}

export function DocumentListHeader({
  searchText,
  onSearchTextChange,
  onQueueFilesUpload,
  showUploadAction,
}: DocumentListHeaderProps) {
  return (
    <div className={styles.root}>
      <div className={styles.searchBar}>
        <SearchField
          embedded
          appearance="toolbar"
          stretch
          className={styles.searchField}
          placeholder="Search Documents"
          value={searchText}
          onChange={onSearchTextChange}
        />
      </div>
      <div className={styles.filterContainer}>
        {showUploadAction && (
          <Tooltip content="Upload document">
            <div className={styles.icon}>
              <FileButton
                multiple={true}
                onChange={onQueueFilesUpload}
                data-test="upload-document-input-classic"
              >
                <Icon name="add" />
              </FileButton>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  )
}
